import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import Icon from 'Pods/Shared/Icon/Icon'

import JobActions from '../../Components/JobActions'

function JobPageContent({ title, jobActions, isResponsive }) {
  return (
    <div className="job-page__nav">
      <div className="container-fixed">
        <div className="job-page__nav-inner">
          {isResponsive ? (
            <Fragment>
              <Link to={{ pathname: '/profile/projects' }} className="link link--primary">
                <Icon type={['far', 'angle-left']} />
              </Link>
              <h1 className="heading-18 job-page__nav-heading">
                {title}
              </h1>
            </Fragment>
          ) : (
            <Fragment>
              <h1 className="heading-18 job-page__nav-heading">
                <Link to={{ pathname: '/profile/projects' }} className="btn btn-outline-default btn-sm u-mr10">
                  <Icon type={['far', 'angle-left']} /> Back to My Projects
                </Link>
                {title}
              </h1>
            </Fragment>
          )}
          <JobActions
            {...jobActions}
          />
        </div>
      </div>
    </div>
  )
}

JobPageContent.propTypes = {
  isResponsive: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  jobActions: PropTypes.object.isRequired,
}

export default JobPageContent
